<template>
  <div class="app-content-wrapper">
    <div v-if="`${app.userLogin.merchantType}` !== '3'" class="search-wrapper card-sort-top margin-bottom-20">
      <el-button v-permission="'checkout:card:add'" size="small" type="primary" icon="el-icon-plus" @click="handleAdd">{{$t('message.common.add')}}</el-button>
    </div>
    <div v-if="`${app.userLogin.merchantType}` === '3'" class="search-wrapper">
      <search-component
        ref="search"
        :search-condition="searchCondition"
        :search-buttons="searchButtonList"
        :hideFuzzySearch="true"
        :showFilterNumber="false"
        :showMerchantSearch="true"
        router-name="/checkout/card"
      ></search-component>
    </div>
    <div class="table-wrapper">
      <custom-table ref="table"
                    :table-set="tableCondition"
                    :service-function="queryCardSortList"
                    :is-first-automatic-visit="false"
                    :showMerchantNo="true"
                    router-name="/checkout/card">
      </custom-table>
    </div>
    <custom-message ref="customMessage"></custom-message>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue } from '@/utils/tools/constant';
import { queryCardSortList, deleteByCountry } from '@/views/checkout/api/card';

export default {
  components: {
    CustomTable,
    CustomMessage,
    SearchComponent,
  },
  data() {
    return {
      countryList: [],
      searchCondition: [],
      searchButtonList: [
        {
          type: 'add',
          permissionCode: 'checkout:card:add',
          func: () => {
            this.handleAdd();
          },
        },
      ],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.transaction.country' },
          key: 'country',
          type: 'text',
          textFunc: (row) => getEnantiomericValue(this.countryList, row.country),
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.LatestOperationTime' },
          key: 'updateTime',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.operator' },
          key: 'operator',
          type: 'text',
        },
        {
          key: 'buttons',
          titleBar: { title: 'message.tableCommon.operation', type: 'operations' },
          type: 'operations',
          itemMinWidth: 120,
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.common.edit',
              permissionCode: 'checkout:card:edit',
              func: async (data) => {
                this.$router.push({ path: '/checkout/card/edit', query: { country: data.country } });
              },
            },
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.see',
              permissionCode: 'checkout:card:view',
              func: async (data) => {
                this.$router.push({ path: '/checkout/card/view', query: { isSee: 1, country: data.country, merchantNo: data.merchantNo } });
              },
            },
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.delete',
              permissionCode: 'checkout:card:delete',
              func: async (data) => {
                this.$refs.customMessage.openHttpModal({
                  titleHtml: this.$t('message.common.prompt'),
                  contentHtml: `${this.$t('message.common.deleteConfirm')}?`,
                  httpFunction: deleteByCountry,
                  params: { country: data.country },
                  successFunction: this.onRefreshTable,
                });
              },
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  mounted() {
    this.initMethod();
  },
  methods: {
    queryCardSortList,
    async initMethod() {
      const dict = await GlobalData.getDictList(['COUNTRY']);
      this.countryList = (dict.COUNTRY || []).map(item => {
        return {
          label: item.description.split('-')[0],
          value: item.value,
        };
      });
      this.countryList.unshift({
        label: 'ALL',
        value: 'ALL',
      });

      this.$refs.table.firstVisitHttp();
    },
    onRefreshTable() {
      this.$refs.table.refreshTable();
    },
    handleAdd() {
      this.$router.push({ path: '/checkout/card/add' });
    },
  },
};
</script>
<style lang="scss" scoped>
.card-sort-top {
  display: flex;
  justify-content: flex-end;
}
</style>
